import React from "react"

ProductAddtinal.propTypes = {}

function ProductAddtinal(props) {
  return <div>ìno </div>
}

export default ProductAddtinal
